// extracted by mini-css-extract-plugin
export default {"container":"Home_container__BGBOz","content":"Home_content__GWLDp","sidebar":"Home_sidebar__I150g"};